// Decides visibility/disabled/tooltip of the writing-assistant button:
// hidden when AI is off; greyed out + hint tooltip when the quota is exhausted.
export function aiButtonState(readOnly: boolean): {
  visible: boolean;
  disabled: boolean;
  tooltip: string;
} {
  const ai = Preload.current_network.ai_service;
  const exhausted = ai?.quota_exhausted === true;
  return {
    visible: ai?.enabled === true,
    disabled: readOnly || exhausted,
    tooltip: exhausted
      ? I18n.t("js.composer.editor.ai.unavailable")
      : I18n.t("js.composer.editor.buttons.ai"),
  };
}
